/**
 * The main entry point for the client.
 */
import clientCommon from './entry-client-common';
import createRouterStore from './create-router-store';

const { router, store } = createRouterStore();

clientCommon({ router, store });
